export function readCart() {
  try {
    const value = localStorage.getItem("ecomm_cart");
    return value ? JSON.parse(value) : [];
  } catch {
    return [];
  }
}

export function saveCart(items) {
  localStorage.setItem("ecomm_cart", JSON.stringify(items));
  window.dispatchEvent(new Event("ecomm-cart-change"));
}

export function readOrders() {
  try {
    const value = localStorage.getItem("ecomm_order_history");
    const orders = value ? JSON.parse(value) : [];
    return Array.isArray(orders) ? orders : [];
  } catch {
    return [];
  }
}

export function saveOrder(entry) {
  localStorage.setItem("ecomm_order_history", JSON.stringify([entry, ...readOrders()]));
  window.dispatchEvent(new Event("order-history-change"));
}
